import fetchAPI from '../fetchAPI';

interface callGetAllBillingAccountProps {
  locationId?: string;
  billingAccountId?: string;
}

export const callGetBillingAccount = async (
  props: callGetAllBillingAccountProps
): Promise<iResponse<{ message: string; data?: BillingAccount[] }>> => {
  const { locationId, billingAccountId } = props;

  const queryParams = new URLSearchParams();
  if (locationId) {
    queryParams.append('locationId', locationId);
  }
  if (billingAccountId) {
    queryParams.append('id', billingAccountId);
  }
  const queryString = queryParams.toString();
  const response: iResponse<{ message: string; data?: BillingAccount[] }> = await fetchAPI({
    method: `GET`,
    route: `billing-accounts`,
    queryString
  });

  return response;
};

export default callGetBillingAccount;
